import React from 'react';
import { Icon } from './Icon.js';
export const IconBolt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polygon", { points: "11 2.5 10.5 8 16 8 9 17.5 9.5 12 4 12 11 2.5", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconBolt.js.map